module.exports = __webpack_public_path__ + "img/lock_closed.b6e98e94.svg";